import React from 'react';
import { Amount } from '@redpanda/ui';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RecentActivity } from '@redpanda/types';
import { formatTableDate } from '@redpanda/utils';

/**
 * 動態記錄一列（儀表板「最近動態」與活動記錄頁共用）
 * 各類型統一成「標題／內容／客戶」三行；不再依類型換顏色（§3-5 顏色只代表狀態）
 */
const ActivityItem: React.FC<{ activity: RecentActivity }> = ({ activity }) => {
  const { t, i18n } = useTranslation();

  const info = (() => {
    switch (activity.type) {
      case 'interaction':
        return { title: activity.title, detail: activity.description, prep: t('dashboard.withCustomer', { ns: 'pages' }) };
      case 'project':
        return { title: activity.title, detail: activity.description, prep: t('dashboard.forCustomer', { ns: 'pages' }) };
      case 'payment':
        return { title: activity.title, detail: activity.description, amount: activity.amount, prep: t('dashboard.fromCustomer', { ns: 'pages' }) };
      case 'quote':
        return { title: activity.title, detail: activity.description, amount: activity.amount, prep: t('dashboard.forCustomer', { ns: 'pages' }) };
      default:
        return null;
    }
  })();

  if (!info) return null;

  return (
    <li className="px-5 py-3.5">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0 space-y-0.5">
          <p className="text-sm font-medium text-fg truncate">{info.title}</p>
          {(info.detail || info.amount != null) && (
            <p className="text-sm text-fg-secondary">
              {info.detail}
              {info.detail && info.amount != null && <span className="mx-1.5 text-fg-muted">·</span>}
              {info.amount != null && <Amount value={info.amount} className="tabular-nums" />}
            </p>
          )}
          <p className="text-[13px] text-fg-secondary">
            {info.prep}{' '}
            <Link to={`/customers/${activity.customer.id}`} className="text-fg hover:text-accent transition-colors">
              {activity.customer.name}
            </Link>
          </p>
        </div>
        <div className="shrink-0 text-[13px] text-fg-secondary tabular-nums">
          {formatTableDate(activity.createdAt, i18n.language)}
        </div>
      </div>
    </li>
  );
};

export default ActivityItem;
